import Prose from '@/components/Prose';
import { ProseProps } from '@/components/Prose/Prose';
import { propClassName } from '@/styles/ContentTextMultiline';
import { ClassNameProp, Component } from '@/types/component';
import { cn } from 'lib/utils/cn';

export interface TextMultilineProps extends Omit<ProseProps, 'markup'> {
  colors?: ClassNameProp;
  markup?: string;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}
const TextMultilineComponent: Component<TextMultilineProps> = ({
  className,
  colors,
  markup,
  size,
  variant,
  ...props
}) => {
  const colorsClassName = propClassName('colors', colors);
  const sizeClassName = propClassName('size', size);
  const variantClassName = propClassName('variant', variant);
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return <Prose options={{ className: componentClassName }} {...{ markup }} {...props} />;
};

export const TextMultiline = TextMultilineComponent;
